import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';
import { Router, ActivatedRoute } from "@angular/router";
import { OrdersService } from './orders.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  providers:[OrdersService]
})
export class OrdersComponent {


     orders:Array<any>;
     ordersData: FirebaseListObservable<any>;
    constructor(public af:AngularFireDatabase,
      public toastr: ToastrService,
      public router:Router,
      public ordersService:OrdersService) {
     this.ordersData = af.list('/orders');
     this.ordersData.subscribe((res)=>{
       //console.log("res" + JSON.stringify(res))
         this.orders = res;
     });   
    }

    OnChangeStatus(key,event){
      this.ordersData.update(key,{status:event.target.value}).then((res)=>{
          var message = { 
          app_id: "ace5d8a2-5018-4523-ab21-cff285d32524",
          contents: {"en": event.target.value},
          include_player_ids: ["31851f36-3730-4c4d-a129-fdcf380d4d86"]
        };

        this.af.list('/orders/'+key+'/statusReading').push({title:event.target.value, time:Date.now()})

         this.ordersService.sendNotification(message).subscribe(response =>{
               console.log("hello "+JSON.stringify(response))
        });
            this.toastr.success('Order status updated!', 'Success!');
        });
    }
     ordersShow(key){
     this.router.navigate(['/order/viewOrder', key]);
  }

}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/orders/orders.component.ts